/*
 *  Document   : candidate-edit.js
 *  Author     : Exapoint
 *
 */

// Import global dependencies

// Import required modules

// Tools

import ExaHelpers from "../exa_helpers";
import Fuse from "fuse.js";

export default class AdministratorConsultantsEdit {

    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["AdministratorConsultantsEdit"] = this;
        this.init();
    }

    /*
     * Updates the color theme
     *
     */
    init() {
        ExaHelpers.select2();

        ExaHelpers.validation();
        this.initValidation();

        AdministratorConsultantsEdit.initLanguagesSelect($('#candidate-edit-languages-select2'));
    }

    initValidation() {
        $('.js-validation').validate({
            ignore: [],
            rules: {
                'gender_id': {
                    required: true,
                },
                'first_name': {
                    required: true,
                },
                'last_name': {
                    required: true,
                },
                'address_line_1': {
                    required: true,
                },
                'city': {
                    required: true,
                },
                'postcode': {
                    required: true,
                },
                'country_id': {
                    required: true,
                },
                'email': {
                    required: true,
                    email: true,
                },
                'mobile_number_intl': {
                    required: true,
                    intlTelNumber: true,
                },
                'phone_number_intl': {
                    intlTelNumber: true,
                },
            },
        });
    }

    static initLanguagesSelect($languagesSelect) {
        let app = this;
        app.removedAcItems = [];

        app.fuse = new Fuse(jsVars.languagesAutocompleteValues, {
            minMatchCharLength: 1,
            threshold: 0.3,
            distance: 1000,
            keys: ["name"],
            getFn: (obj, path) => {
                return obj.name.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            }
        })

        let $jtAc = $languagesSelect;
        let selectedValues = [];
        $('[type="hidden"][name*="userable[languages]"]').each(function (_i, val) {
            let parsedId = parseInt(ExaHelpers.extractFieldFromName($(val).prop('name')));
            if (!isNaN(parsedId)) {
                selectedValues.push(parsedId);
            }
        })

        $jtAc.autocomplete({
            delay: 0,
            minLength: 0,
            source: function (req, callback) {
                let term = req.term.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

                let options = [];
                $.each(app.fuse.search(term, {limit: 10}), function (index, obj) {
                    options.push({value: obj.item.id, label: obj.item.name, wholeObject: obj.item});
                });

                callback(options);
            },
            select: function (event, ui) {
                var label = ui.item.label;
                var value = ui.item.value;

                let indexToRemove = app.fuse._docs.findIndex(x => x.id === parseInt(value));
                if (indexToRemove !== -1) {
                    app.removedAcItems.push(app.fuse._docs[indexToRemove]);
                    app.fuse.removeAt(indexToRemove);
                }

                let newValue = ui.item.wholeObject;

                // Custom part - start
                let $table = $('.languages-table');

                let $htmlToAppend = $(app.languagesRowTemplate(newValue, null));

                $table.find('tbody').append($htmlToAppend);

                if ($table.find('tr.single-language') && $table.find('tr.single-language').length !== 0) {
                    $table.show();
                } else {
                    $table.hide();
                }

                // Custom part - end

                $(this).val('');
                return false;
            },
            focus: function (event, ui) {
                $(this).val(ui.item.label);
                return false;
            }
        });

        $.each(selectedValues, function (_i, value) {
            let indexToRemove = app.fuse._docs.findIndex(x => x.id === parseInt(value));
            if (indexToRemove !== -1) {
                app.removedAcItems.push(app.fuse._docs[indexToRemove]);
                app.fuse.removeAt(indexToRemove);
            }
        })

        let $table = $('.languages-table');
        $table.on('click', '.remove-language-row', function (e) {
            let $target = $(e.target);
            $target.parents('.single-language').remove();
        })
    }

    static languagesRowTemplate(datarecord, idx) {
        return `
            <tr class="single-language">
                <td><i class="fa fa-fw fa-times remove-language-row"></i> ${datarecord.name}</i></td>
                <td><input name="userable[languages][${datarecord.id}]" type="hidden"></td>
            </tr>
            `;
    }
}
